import { render, staticRenderFns } from "./LoadResults.vue?vue&type=template&id=4047793a&scoped=true&"
import script from "./LoadResults.vue?vue&type=script&lang=js&"
export * from "./LoadResults.vue?vue&type=script&lang=js&"
import style0 from "./LoadResults.vue?vue&type=style&index=0&id=4047793a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047793a",
  null
  
)

export default component.exports